<template>
	<div class="Medien">
		<div class="container">
			<h1>{{ $t('navigationMedien.title') }}</h1>
			<div class="row align-items-center h-50">
				<div class="py-5 col-9">
					<div class="Medien__VideoSection">
						<h4>
							{{ $t('navigationMedien.medium1.title') }}
						</h4>
						<div class="Medien__VideoDescription">
							{{ $t('navigationMedien.medium1.description') }}
							<router-link :to="{ name: 'Grad1Infight' }">
								S.T.O.R.M®</router-link
							>
						</div>
						<div v-if="consentAllowed || youtubeIsAllowed">
							<iframe
								:width="computedIframeWidth"
								:height="computedIframeHeight"
								src="https://www.youtube.com/embed/OSm-kdLEDGM"
								frameborder="0"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
								allowfullscreen
							></iframe>
							<div
								v-if="!consentAllowed"
								v-on:click="onDisallowApp()"
								class="Medien__OptOutRequest"
							>
								{{ $t('navigationMedien.revokeYoutubePermissionButtton') }}
							</div>
						</div>

						<div v-else>
							<google-apps-overlay
								:description="$t('navigationMedien.blockerTextYoutube')"
								type="videos"
								@onAllowApp="onAllowApp"
							/>
						</div>
					</div>
					<div class="Medien__VideoSection">
						<h4>
							{{ $t('navigationMedien.medium2.title') }}
						</h4>
						<div class="Medien__VideoDescription">
							{{ $t('navigationMedien.medium2.description') }}
						</div>
						<div v-if="consentAllowed || youtubeIsAllowed">
							<iframe
								:width="computedIframeWidth"
								:height="computedIframeHeight"
								src="https://www.youtube.com/embed/KlRk885MHXk"
								frameborder="0"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
								allowfullscreen
							></iframe>
							<div
								v-if="!consentAllowed"
								v-on:click="onDisallowApp()"
								class="Medien__OptOutRequest"
							>
								{{ $t('navigationMedien.revokeYoutubePermissionButtton') }}
							</div>
						</div>

						<div v-else>
							<google-apps-overlay
								:description="$t('navigationMedien.blockerTextYoutube')"
								type="videos"
								@onAllowApp="onAllowApp"
							/>
						</div>
					</div>
					<div class="Medien__VideoSection">
						<h4>
							{{ $t('navigationMedien.medium3.title') }}
						</h4>
						<div class="Medien__VideoDescription">
							{{ $t('navigationMedien.medium3.description') }}
							<router-link :to="{ name: 'Grad1Infight' }">
								S.T.O.R.M®</router-link
							>
							{{ $t('navigationMedien.medium3.description1') }}
							<router-link :to="{ name: 'Grad3Infight' }">
								C.A.T.S.</router-link
							>
							{{ $t('navigationMedien.medium3.description2') }}
						</div>
						<div v-if="consentAllowed || youtubeIsAllowed">
							<iframe
								:width="computedIframeWidth"
								:height="computedIframeHeight"
								src="https://www.youtube.com/embed/Asr44grPj34"
								frameborder="0"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
								allowfullscreen
							></iframe>
							<div
								v-if="!consentAllowed"
								v-on:click="onDisallowApp()"
								class="Medien__OptOutRequest"
							>
								{{ $t('navigationMedien.revokeYoutubePermissionButtton') }}
							</div>
						</div>

						<div v-else>
							<google-apps-overlay
								:description="$t('navigationMedien.blockerTextYoutube')"
								type="videos"
								@onAllowApp="onAllowApp"
							/>
						</div>
					</div>
					<div class="Medien__VideoSection">
						<h4>
							{{ $t('navigationMedien.medium4.title') }}
						</h4>
						<div class="Medien__VideoDescription">
							{{ $t('navigationMedien.medium4.description') }}
							<router-link :to="{ name: 'Grad3Infight' }">
								C.A.T.S.</router-link
							>
						</div>
						<div v-if="consentAllowed || youtubeIsAllowed">
							<iframe
								:width="computedIframeWidth"
								:height="computedIframeHeight"
								src="https://www.youtube.com/embed/yGAJxiM3-s4"
								frameborder="0"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
								allowfullscreen
							></iframe>
							<div
								v-if="!consentAllowed"
								v-on:click="onDisallowApp()"
								class="Medien__OptOutRequest"
							>
								{{ $t('navigationMedien.revokeYoutubePermissionButtton') }}
							</div>
						</div>

						<div v-else>
							<google-apps-overlay
								:description="$t('navigationMedien.blockerTextYoutube')"
								type="videos"
								@onAllowApp="onAllowApp"
							/>
						</div>
					</div>
					<div class="Medien__VideoSection">
						<h4>
							{{ $t('navigationMedien.medium5.title') }}
						</h4>
						<div class="Medien__VideoDescription">
							{{ $t('navigationMedien.medium5.description') }}
							<router-link :to="{ name: 'Grad4Postfight1' }">
								Travel Security</router-link
							>
						</div>
						<div class="Medien_ExternalVideoSection">
							<a
								href="https://www.prosieben.de/tv/galileo/videos/2015-galileo-beim-anti-terror-training-teil-2-clip"
								target="_blank"
								>Galileo beim Anti-Terror-Training Teil 2
								<open-in-new-icon :size="20" />
							</a>
						</div>
					</div>
					<div class="Medien__VideoSection">
						<h4>
							{{ $t('navigationMedien.medium6.title') }}
						</h4>
						<div class="Medien__VideoDescription">
							{{ $t('navigationMedien.medium6.description') }}
							<router-link :to="{ name: 'Grad4Postfight1' }">
								Travel Security</router-link
							>
							{{ $t('navigationMedien.medium6.description1') }}
						</div>
						<div class="Medien_ExternalVideoSection">
							<a
								href="https://www.prosieben.de/tv/follow-us/video/13-baris-beim-antiterrortraining-run-hide-fight-clip"
								target="_blank"
								>Baris beim Antiterrortraining: run, hide & fight
								<open-in-new-icon :size="20"
							/></a>
						</div>
					</div>
					<div class="Medien__VideoSection">
						<h4>
							{{ $t('navigationMedien.medium7.title') }}
						</h4>
						<div class="Medien__VideoDescription">
							{{ $t('navigationMedien.medium7.description') }}
							<router-link :to="{ name: 'Grad4Postfight1' }">
								Travel Security</router-link
							>
							{{ $t('navigationMedien.medium7.description1') }}
						</div>
						<div class="Medien_ExternalVideoSection">
							<a
								href="https://www.prosieben.de/tv/galileo/videos/2016285-wie-kann-ich-mich-im-extremfall-vor-einem-amoklaeufer-schuetzen-clip"
								target="_blank"
								>Wie kann ich mich im Extremfall vor einem Amokläufer schützen?
								<open-in-new-icon :size="20" />
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import GoogleAppsOverlay from '@/components/GoogleAppsOverlay'
import OpenInNewIcon from 'vue-material-design-icons/OpenInNew.vue'

export default {
	name: 'Medien',
	components: {
		GoogleAppsOverlay,
		OpenInNewIcon
	},
	data() {
		return {
			computedIframeWidth: this.setIframeWidth(),
			computedIframeHeight: this.setIframeHeight()
		}
	},
	computed: {
		consentAllowed() {
			return this.$store.getters.cookieIsSet
		},
		youtubeIsAllowed() {
			return this.$store.getters.youtubeIsAllowed
		}
	},
	methods: {
		onAllowApp() {
			this.$store.commit('onAllowYoutube')
		},
		onDisallowApp() {
			this.$store.commit('onDisallowYoutube')
		},
		onResizeWindow() {
			this.computedIframeWidth = this.setIframeWidth()
			this.computedIframeHeight = this.setIframeHeight()
		},
		setIframeWidth() {
			if (window.innerWidth >= 1500) {
				return 950
			} else if (window.innerWidth >= 1200) {
				return 850
			} else if (window.innerWidth >= 1024) {
				return 800
			} else if (window.innerWidth >= 992) {
				return 750
			} else if (window.innerWidth >= 768) {
				return 650
			} else if (window.innerWidth >= 568) {
				return 500
			} else if (window.innerWidth < 568 && window.innerWidth >= 500) {
				return 400
			} else if (window.innerWidth < 500 && window.innerWidth >= 400) {
				return 350
			} else if (window.innerWidth < 400 && window.innerWidth >= 350) {
				return 300
			} else if (window.innerWidth < 350) {
				return 270
			}
		},
		setIframeHeight() {
			if (window.innerWidth >= 1500) {
				return 500
			} else if (window.innerWidth >= 1200) {
				return 500
			} else if (window.innerWidth >= 1024) {
				return 500
			} else if (window.innerWidth >= 992) {
				return 500
			} else if (window.innerWidth >= 768) {
				return 450
			} else if (window.innerWidth >= 568) {
				return 400
			} else if (window.innerWidth < 568 && window.innerWidth >= 500) {
				return 350
			} else if (window.innerWidth < 500 && window.innerWidth >= 400) {
				return 300
			} else if (window.innerWidth < 400 && window.innerWidth >= 350) {
				return 300
			} else if (window.innerWidth < 350) {
				return 270
			}
		}
	},
	mounted() {
		window.addEventListener('resize', this.onResizeWindow)
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResizeWindow)
	},
	i18n: {
		messages: {
			de: require('@/i18n/de/de_medien.json'),
			en: require('@/i18n/en/eng_medien.json')
		}
	}
}
</script>

<style scoped lang="styl">
a, .Medien__Icon {
	color: red;
}
.Medien__VideoSection {
	margin-bottom: 6rem;
}
.Medien__VideoDescription {
	margin-bottom: 2rem;
}
.Medien_ExternalVideoSection span {
	margin-left: 0.2rem;
}

iframe {
	border: 3px solid rgba(11,38,46,0.8);
}
.Medien__OptOutRequest {
	margin-top: 10px;
	font-size: 10px;
	cursor: pointer;
}
</style>
